<template>
    <footer class="site-footer">
        <div class="footer-inner">

            <div class="footer-brand">
                <div class="footer-logo" @click="$router.push('/')">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="36px" height="36px" viewBox="254.384 375.649 40 40" enable-background="new 254.384 375.649 140 140" xml:space="preserve">
                        <path fill="#FFFFFF" d="M254.384,375.649v40h40v-40H254.384z M261.734,408.148h-3.621l4.884-24.941l7.427,16.818l-1.823,3.992  l-4.373-9.889L261.734,408.148z M275.791,408.148v-2.901h3.749l-1.774-11.103l-6.385,14.003h-6.036v-2.901h3.782l10.078-22.041  l4.388,24.941H275.791z M290.574,394.204c-0.95,1.356-2.342,2.361-3.933,2.838c-0.917,0.273-3.876,0.769-3.876,0.769l-0.576-3.259  c0.893-0.157,1.795-0.292,2.682-0.481c0.843-0.179,1.693-0.454,2.346-1.037c0.671-0.597,1.142-1.408,1.327-2.287  c0.107-0.518,0.116-1.053,0.025-1.575c-0.095-0.519-0.286-1.021-0.563-1.472c-0.475-0.763-1.196-1.362-2.031-1.694  c-0.815-0.324-1.707-0.291-2.559-0.168c-0.897,0.128-1.791,0.309-2.685,0.469l-0.576-3.257c0-0.002,1.012-0.181,1.076-0.193  c0.938-0.168,1.875-0.361,2.83-0.418c1.659-0.099,3.311,0.368,4.669,1.316c1.646,1.148,2.746,2.865,3.099,4.839l0,0v0.002l0,0  C292.168,390.569,291.725,392.563,290.574,394.204z"/>
                    </svg>
                    <span class="footer-brand-name">Engineers <span class="plus">+</span> Architects</span>
                </div>
                <p class="footer-tagline">Multi-Disciplinary Consulting Firm<br>Founded 2006 &mdash; DBE / MBE / SBE Certified</p>
                <a
                    href="https://www.linkedin.com/company/mp-engineers-architects"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="footer-linkedin"
                    aria-label="MP Engineers + Architects on LinkedIn"
                >
                    <i class="fab fa-linkedin"></i> LinkedIn
                </a>
            </div>

            <div class="footer-nav">
                <div class="footer-nav-column">
                    <div class="footer-nav-heading">Company</div>
                    <router-link to="/about">About</router-link>
                    <router-link to="/expertise">Expertise</router-link>
                    <router-link to="/projects/all">Projects</router-link>
                    <router-link to="/people">Leadership</router-link>
                </div>
                <div class="footer-nav-column">
                    <div class="footer-nav-heading">Connect</div>
                    <router-link to="/offices">Offices</router-link>
                    <router-link to="/careers">Careers</router-link>
                    <a href="mailto:info@mpengs.com">info@mpengs.com</a>
                    <a href="tel:+12127361100">(212) 736-1100</a>
                </div>
            </div>

        </div>

        <div class="footer-bottom">
            <span>&copy; {{ currentYear }} MP Engineers + Architects, P.C. All rights reserved.</span>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'SiteFooter',
    computed: {
        currentYear() {
            return new Date().getFullYear();
        },
    },
};
</script>

<style scoped>
.site-footer {
    background-color: #054d81;
    color: #fff;
    width: 100%;
    margin-top: auto;
}

.footer-inner {
    display: flex;
    flex-wrap: wrap;
    gap: 40px;
    justify-content: space-between;
    width: 90vw;
    max-width: 1600px;
    margin: 0 auto;
    padding: 40px 0 30px;
}

.footer-brand {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 300px;
}

.footer-logo {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
}

.footer-brand-name {
    font-size: 1.1rem;
    font-weight: 600;
    color: #fff;
    letter-spacing: 0.03rem;
}

.plus {
    color: #ff6404;
    margin: 0 2px;
}

.footer-tagline {
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.7);
    line-height: 1.5;
    margin: 0;
}

.footer-linkedin {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-size: 0.9rem;
    transition: color 0.2s;
}

.footer-linkedin:hover {
    color: #fff;
}

.footer-nav {
    display: flex;
    gap: 60px;
    flex-wrap: wrap;
}

.footer-nav-column {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.footer-nav-heading {
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.1rem;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.5);
    margin-bottom: 4px;
}

.footer-nav-column a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-size: 0.9rem;
    transition: color 0.2s;
}

.footer-nav-column a:hover {
    color: #fff;
}

.footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    width: 90vw;
    max-width: 1600px;
    margin: 0 auto;
    padding: 16px 0;
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.5);
}

@media (max-width: 768px) {
    .footer-inner {
        flex-direction: column;
        gap: 30px;
        padding: 30px 0 20px;
    }

    .footer-brand {
        max-width: 100%;
    }

    .footer-nav {
        gap: 30px;
    }
}
</style>
